module.exports = __webpack_public_path__ + "static/media/about-banner.669a21fa.png";